<div
  class="bg-primary-50 border-r border-primary-100 top-0 hidden lg:block z-10 w-66 h-screen transition-all duration-500 fixed"
  [ngClass]="isLeftSidebarCollapsed() ? 'w-[5rem]' : ''"
>
  <!-- Sidebar Header -->
  <div class="flex items-center w-full p-4">
    <button
      class="text-center items-center justify-center flex h-12 w-12 rounded-md p-1 text-2xl font-black cursor-pointer min-w-[3rem] bg-primary-500 border-none"
      (click)="toggleCollapse()"
    >
      <i class="pi pi-bars dark:text-foreground"></i>
    </button>
    @if (!isLeftSidebarCollapsed()) {
      <div class="ml-6 text-2xl font-bold text-foreground truncate">Food Fitness</div>
    }
  </div>

  <!-- Sidebar Menu -->
  <ul
    style="scrollbar-width: none"
    class="p-4 m-0 flex flex-col items-center list-none h-[calc(100%-3.65rem)] w-full overflow-y-auto"
  >
    @for (item of items(); track item.routeLink ?? item.label) {
      <li class="w-full mb-1" [pTooltip]="isLeftSidebarCollapsed() ? item.label : ''">
        <!-- Parent or Leaf -->
        <!-- [class.px-2]="isLeftSidebarCollapsed()" -->
        <div
          class="flex items-center h-12 text-foreground no-underline rounded-lg cursor-pointer truncate px-2 hover:bg-primary-500 hover:text-black"
          (click)="handleItemClick(item)"
          [routerLink]="!item.isParent ? item.routeLink : null"
          [routerLinkActive]="'bg-primary-500'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <i class="text-xl w-8 text-center text-foreground min-w-[2rem]" [class]="item.icon"></i>
          @if (!isLeftSidebarCollapsed()) {
            <span
              [routerLinkActive]="!item.isParent ? 'font-bold' : ''"
              class="ml-4 flex-1 text-sm"
              >{{ item.label }}</span
            >
            @if (item.isParent) {
              <i class="pi" [ngClass]="item.expanded ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            }
          }
        </div>
      </li>
    }
  </ul>
</div>
<p-drawer
  [(visible)]="visible"
  position="left"
  [modal]="true"
  appendTo="body"
  [blockScroll]="true"
  [autoZIndex]="true"
  [baseZIndex]="10000"
  (onHide)="closeDrawer()"
>
  <!-- Sidebar Header -->
  <div class="flex items-center w-full p-4 border-b border-primary-100">
    <div class="ml-2 text-2xl font-bold text-foreground truncate">Food Fitness</div>
  </div>

  <!-- Sidebar Menu -->
  <ul class="p-4 m-0 flex flex-col list-none w-full overflow-y-auto" style="scrollbar-width: none">
    <li *ngFor="let item of items()" class="w-full mb-1">
      <div
        class="flex items-center h-12 text-foreground rounded-lg cursor-pointer truncate px-2 hover:bg-primary-500 hover:text-black transition-colors duration-200"
        (click)="handleDrawerItemClick(item)"
        [routerLink]="!item.isParent ? item.routeLink : null"
        routerLinkActive="bg-primary-500"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <!-- Icon -->
        <i class="text-xl w-8 text-center text-foreground min-w-[2rem]" [class]="item.icon"></i>

        <!-- Label -->
        <span class="ml-4 flex-1 text-sm">
          {{ item.label }}
        </span>

        <!-- Expand Arrow -->
        <i
          *ngIf="item.isParent"
          class="pi"
          [ngClass]="item.expanded ? 'pi-chevron-down' : 'pi-chevron-right'"
        ></i>
      </div>
    </li>
  </ul>
</p-drawer>
